import { ReactElement } from 'react';
import { PredictionInspectorContainer } from '../../../../modules/jobs/containers/predictionInspector/PredictionInspector.container';
import { JOB_TYPE } from '../../../../modules/jobs/jobs.model';

export const TrainingDetailsPredictionInspectorView = (): ReactElement => {
  return <PredictionInspectorContainer jobType={JOB_TYPE.TRAINING} />;
};
